import React, { useState } from 'react';
import DicomSenderAll from '../bottom/SendDicomAll';

const Sidebar = ({
  rolUsuario,
  onFilterToggle,
  onNavigation,
  onToggleTemplate,

}) => {
  // 1. Estado para controlar si el sidebar está abierto (expandido) o cerrado (colapsado)
  const [isOpen, setIsOpen] = useState(false);

  // 2. Función para alternar el estado
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  // 3. Clases dinámicas de Tailwind CSS

  // Clase base para los botones de navegación
  const commonButtonClass =
    'flex hover:bg-primary-main justify-start justify-items-center rounded p-1 w-full text-white my-2';

  // Propiedades comunes para los iconos SVG. Añadimos flex-shrink-0 para que el icono no se encoja.
  const iconProps = {
    width: isOpen ? '35' : '25',
    height: isOpen ? '35' : '25',
    fill: 'currentColor',
    className: 'text-gray-500 flex-shrink-0'
  };

  // Clase para ocultar o mostrar el texto y el título.
  const textVisibilityClass = isOpen ? '' : 'hidden';

  // Ancho dinámico para el contenedor principal. (w-64 = 256px, w-20 = 80px)
  const sidebarWidthClass = isOpen ? 'w-64' : 'w-12';

  // Clases combinadas para el aside, incluyendo la transición para un efecto suave.
  const asideClasses = `bg-gradient-to-t from-secondary-dark  fixed ${isOpen ? 'top-0 h-screen' : 'top-12 h-[calc(100vh-3rem)]'} left-0 z-40 transition-all duration-300 ${sidebarWidthClass} -translate-x-full sm:translate-x-0`;

  // Icono dinámico para el botón de alternancia (abrir/cerrar)
  const toggleIcon = isOpen ? (
    <svg xmlns="http://www.w3.org/2000/svg" {...iconProps} viewBox="0 0 16 16">
      <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z" />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" {...iconProps} viewBox="0 0 16 16">
      <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
    </svg>
  );

  // Función auxiliar para renderizar los elementos de navegación (para no duplicar código)
  const renderLink = (label, iconContent, onClick, extraClass = '') => (
    <li>
      <button
        className={`${commonButtonClass} ${extraClass}`}
        onClick={onClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          {...iconProps}
          viewBox="0 0 25 25"
        >
          {iconContent}
        </svg>
        {/* El texto se oculta si no está abierto */}
        <span className={`ml-3 whitespace-nowrap overflow-hidden ${textVisibilityClass}`}>
          {label}
        </span>
      </button>
    </li>
  );

  return (
    <aside
      className={asideClasses}
      aria-label="Sidenav"
    >
      <div className="flex flex-col h-full overflow-y-auto overflow-x-hidden py-2">
        {/* Bloque del Título y Botón de Toggle */}
        <div className="sticky top-0 flex justify-between items-center px-3 pt-3 z-10">
          <h1 className={`text-2xl text-white font-bold whitespace-nowrap overflow-hidden ${textVisibilityClass}`}>
            Menu
          </h1>
          <button
            onClick={toggleSidebar} // Llama a la función de alternancia
            // Ajusté las clases para que el botón se vea bien en ambos estados (abierto/cerrado)
            className="text-white focus:ring-4 focus:outline-none focus:ring-plom-secondary font-medium rounded-lg text-sm dark:focus:ring-plom-secondary flex items-center justify-center transition-all duration-300"
          >
            {toggleIcon}
            {/* Texto del botón (Cerrar/Abrir) se oculta en modo colapsado */}
          </button>
        </div>

        {/* Separador - Se oculta en modo colapsado */}
        <hr className={`w-auto mx-3 h-1 border-0 rounded-sm my-5 bg-gray-200`}></hr>

        {/* Lista de Navegación */}
        <ul className="space-y-2 px-3">
          {/* Filter (Duplicado en tu código original, se mantiene para la estructura, puedes eliminar uno) */}
          {renderLink(
            'Inicio', // Dejé 'Overview' porque así estaba en tu segundo elemento.
            <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5z" />,
            onFilterToggle
          )}

          {/* Botones Admin - Condicionales */}
          {rolUsuario === 'admin' && (
            <>
              {/* Template */}
              {renderLink(
                'Template',
                <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V9H2V2a2 2 0 0 1 2-2m5.5 1.5v2a1 1 0 0 0 1 1h2zM2 12h12v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zM.5 10a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z" />,
                onToggleTemplate
              )}
            </>
          )}

          {/* Reload */}
          {renderLink(
            'Refrescar',
            (
              <>
                <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9" />
                <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z" />
              </>
            ),
            () => { window.location.reload(); },
            'text-white mt-2'
          )}

          {rolUsuario === 'admin' && (
            <li>
              <DicomSenderAll isOpen={isOpen} />
            </li>
          )}

          {/* Elementos Ocultos */}
          <span className="hidden">
            {renderLink(
              'Pacients',
              (
                <>
                  <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                  <path d="M2 13c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4" />
                </>
              ),
              () => onNavigation('/pacients')
            )}
          </span>
          <span className="hidden">
            {renderLink(
              'Appointments',
              (
                <>
                  <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                </>
              ),
              () => onNavigation('/appointments')
            )}
          </span>
        </ul>
        <ul className="mt-auto px-3">
          {/* Settings */}
          {renderLink(
            'Ajustes',
            <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z" />,
            () => onNavigation('/configuration'),
          )}
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
